// Small "not synced yet" indicator. Renders nothing unless the item
// carries the client-only `_queued` flag set by the offline write
// queue. The flag clears automatically once the sync drainer replays
// the write and the cache mutator runs with the real server response.
//
// One component, one style — used inline next to shopping items,
// to-dos, calendar events, etc. so the visual language stays
// consistent everywhere.

export function QueuedDot({ queued }: { queued?: boolean }) {
  if (!queued) return null;
  return (
    <span
      className="queued-dot"
      title="Not synced yet — will save when you're back online"
      aria-label="Pending sync"
    />
  );
}
